// extracted by mini-css-extract-plugin
export var page = "pageTotal-module--page--r3-kl";
export var d1 = "pageTotal-module--d1--RppiB";
export var d2 = "pageTotal-module--d2--YLtWr";
export var line1 = "pageTotal-module--line1--5dAnY";
export var totalNumbers = "pageTotal-module--totalNumbers--uLlPj";
export var listenLine = "pageTotal-module--listenLine--MRsVW";